import React from 'react';
import { Printer } from 'lucide-react';

export default function PrintButton({ label = 'Print / Save as PDF', className = '' }) {
  const handleClick = () => {
    try {
      window.print();
    } catch {
      // no-op
    }
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="print-button"
      aria-label="Print or save this page as PDF"
      className={`tf-no-print inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-[12px] font-bold ${className}`}
      style={{
        background: '#fff',
        color: 'var(--tf-purple)',
        border: '1px solid var(--tf-purple-light)',
      }}
    >
      <Printer size={13} strokeWidth={2.2} />
      {label}
    </button>
  );
}
